import './AppointmentActions.scss';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  cancelAppointment,
  declineAppointment,
  noShowAppointment,
} from 'actions/appointments';
import Button from 'atoms/button';
import useQuery from 'hooks/useQuery';
import { closeDrawer } from 'store/reducers/ui';
import { appointmentsSuccessAlert } from 'util';

import { refreshAppointments, trackAppointmentAction } from './util';

export default function ActionModalContent({ modalData, closeModal }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const query = useQuery();

  const onConfirm = () => {
    let action;
    if (modalData.status === 'no-show') action = noShowAppointment;
    if (modalData.status === 'cancel') action = cancelAppointment;
    if (modalData.status === 'decline') action = declineAppointment;
    dispatch(action(modalData.appointment.uuid)).then(({ success }) => {
      closeModal();
      dispatch(closeDrawer());
      if (success) {
        trackAppointmentAction(modalData.status);
        refreshAppointments({ location, query, dispatch });
        appointmentsSuccessAlert(modalData.status);
      }
    });
  };

  return (
    <div className="flex-column align-center appointment-actions-modal">
      <h2>{modalData.title}</h2>
      <p>{modalData.description}</p>
      <div className="flex-row">
        <Button size="small" onClick={onConfirm} text="Confirm" />
        <Button
          size="small"
          variant="reverse"
          onClick={closeModal}
          text="Cancel"
        />
      </div>
    </div>
  );
}
